import { useEffect } from 'react'


// Redux.
import { connect } from 'react-redux';

// Firebase.
import { getAnalytics, logEvent } from "firebase/analytics";
import 'firebase/compat/auth';
import BottomMenu from '../components/BottomMenu';
import TopBar from '../components/TopBar';
// Components.


const Support = () => {

    useEffect(() => {
        const analytics = getAnalytics();
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'support'
        });
    }, []);

    return (
        <div className="container hasBottomMenu appScreen">
            <BottomMenu />
            <div style={{ paddingBottom: '20px' }}>
                <TopBar />
                <main
                    className='horizontalCenter'
                    style={{
                        minWidth: 0,
                        overflowWrap: 'break-word',
                    }}
                >
                    <div
                        style={{
                            width: '100%',
                            textAlign: 'left',
                            padding: '8px 20px 56px',
                        }}
                    >
                        <h1 style={{ fontSize: '28px', marginBottom: '10px' }}>Support</h1>
                        <p style={{ fontSize: '16px', marginBottom: '28px' }}>
                            Contact:{' '}
                            <a href="mailto:john@podeux.com" style={{ textDecoration: 'underline' }}>
                                john@podeux.com
                            </a>
                        </p>

                        <section style={{ marginBottom: '24px' }}>
                            <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Request Account Deletion</h2>
                            <ol style={{ paddingLeft: '22px', fontSize: '16px' }}>
                                <li style={{ marginBottom: '10px' }}>Open Podeux and sign in to the account you want deleted.</li>
                                <li style={{ marginBottom: '10px' }}>On the home screen, tap the More button.</li>
                                <li style={{ marginBottom: '10px' }}>Tap Delete account.</li>
                                <li style={{ marginBottom: '10px' }}>Read the confirmation screen, then tap Delete Account.</li>
                                <li style={{ marginBottom: '0' }}>Podeux will mark your account for deletion and sign you out.</li>
                            </ol>
                        </section>

                        <section style={{ marginBottom: '24px' }}>
                            <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Need Help Deleting Your Account?</h2>
                            <p style={{ fontSize: '16px', marginBottom: '10px' }}>
                                If you cannot access the app, email{' '}
                                <a href="mailto:john@podeux.com?subject=Podeux%20account%20deletion%20request" style={{ textDecoration: 'underline' }}>
                                    john@podeux.com
                                </a>{' '}
                                with the subject "Podeux account deletion request" and the phone number associated with your account.
                            </p>
                            <p style={{ fontSize: '16px' }}>
                                You can cancel a pending deletion during the retention period by signing in and tapping Do not delete my account.
                            </p>
                        </section>

                        <section style={{ marginBottom: '24px' }}>
                            <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Data Deleted</h2>
                            <p style={{ fontSize: '16px', marginBottom: '10px' }}>
                                When your account is permanently deleted, Podeux deletes or de-identifies personal data tied to your account from active systems, including:
                            </p>
                            <ul style={{ paddingLeft: '22px', fontSize: '16px' }}>
                                <li style={{ marginBottom: '8px' }}>account profile and sign-in information, including your phone number;</li>
                                <li style={{ marginBottom: '8px' }}>saved lists, saved episodes, notes, playback activity, and other library activity;</li>
                                <li style={{ marginBottom: '8px' }}>topic, speaker, show, notification, and personalization preferences;</li>
                                <li style={{ marginBottom: '0' }}>account-linked support, feedback, and chat activity.</li>
                            </ul>
                        </section>

                        <section style={{ marginBottom: '24px' }}>
                            <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Data Kept and Retention</h2>
                            <p style={{ fontSize: '16px', marginBottom: '10px' }}>
                                Your account is hidden immediately after you request deletion. Account data is kept for up to 30 days so you can cancel the request, then it is permanently deleted from active systems.
                            </p>
                            <p style={{ fontSize: '16px', marginBottom: '10px' }}>
                                Podeux may keep limited records for security, fraud prevention, troubleshooting, legal compliance, or backup recovery. These records are retained only as needed and no longer than 12 months after account termination unless a longer period is required by law.
                            </p>
                            <p style={{ fontSize: '16px' }}>
                                Podeux may also keep aggregated or de-identified analytics that do not identify you, and podcast content or metadata that is not specific to your account.
                            </p>
                        </section>
                    </div>
                </main>
            </div>
        </div>
    );
}

Support.propTypes = {

}

Support.defaultProps = {

}

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(Support);
